var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 5.5,
    stroke: "#04B7EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C8.688 6.5 6 9.188 6 12.5C6 15.812 8.688 18.5 12 18.5C15.312 18.5 18 15.812 18 12.5C18 9.188 15.312 6.5 12 6.5ZM11.4 17.258C9.03 16.964 7.2 14.948 7.2 12.5C7.2 12.128 7.248 11.774 7.326 11.426L10.2 14.3V14.9C10.2 15.56 10.74 16.1 11.4 16.1V17.258ZM15.54 15.734C15.384 15.248 14.94 14.9 14.4 14.9H13.8V13.1C13.8 12.77 13.53 12.5 13.2 12.5H9.6V11.3H10.8C11.13 11.3 11.4 11.03 11.4 10.7V9.5H12.6C13.26 9.5 13.8 8.96 13.8 8.3V8.054C15.558 8.768 16.8 10.49 16.8 12.5C16.8 13.748 16.32 14.882 15.54 15.734Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.e29144de66d7638644f7dec80ad29ad0.svg";
export { ForwardRef as ReactComponent };